// @ts-ignore
import { registerVueWidgetForJsp } from "@/Registry";
// @ts-ignore
import { defineComponent, type PropType } from "@/common/vueUtils";
// @ts-ignore
import type { TranslationFn } from "@utils/vue-migration/translationUtils";
// @ts-ignore
import type { HasFeatureFn, HasAccessFunction } from "@utils/widgetContextUtils";
// @ts-ignore
import { ActionableReflectSection } from "@/components/actionable/actionable-page/ActionableReflectSection";
// @ts-ignore
import { ActionableActionbar } from "@/components/actionable/actionable-page/ActionableActionbar";
// @ts-ignore
import { FullSearch } from "@/components/search/FullSearch";
// @ts-ignore
import { AskGetabstractWidget } from "@/components/ask-getabstract/AskGetabstract";
// @ts-ignore
import { AskGetabstractIframe } from "@/components/ask-getabstract/AskGetabstractIframe";
// @ts-ignore
import { AskGetabstractDemo } from "@/components/ask-getabstract/demo/AskGetabstractDemo";
// @ts-ignore
import { VerifaiCreatorPage } from "@/components/verifai/VerifaiCreatorPage";
// @ts-ignore
import { VerifaiNavigation } from "@/components/verifai/VerifaiNavigation";
// @ts-ignore
import { GaTopLayer } from "@/components/general/GaTopLayer";
// @ts-ignore
import { Warmup } from "@/components/warmup/Warmup";
// @ts-ignore
import { WarmupDemo } from "@/components/warmup/demo/WarmupDemo";
// @ts-ignore
import { ModalDemo } from "@/components/general/demo/ModalDemo";
// @ts-ignore
import { ExperimentalGeneratorDemo } from "@/components/demo/ExperimentalGeneratorDemo";
// @ts-ignore
import { GaProgressCircleDemo } from "@/components/general/demo/GaProgressCircleDemo";
// @ts-ignore
import { SummaryCardDefaultDemo } from "@/components/cards/SummaryCardDemo";
// @ts-ignore
import { SummaryCardCompactDemo } from "@/components/cards/SummaryCardDemo";
// @ts-ignore
import { SummaryCardMiniDemo } from "@/components/cards/SummaryCardDemo";
// @ts-ignore
import { FullSearchAiDemoComponent } from "@/components/search/FullSearchAiDemoComponent";
// @ts-ignore
import { MIABPage } from "@/components/miab/MIABPage";
// @ts-ignore
import { BadgeDemo } from "@/components/general/demo/BadgeDemo";
// @ts-ignore
import { GaFeedbackDemo } from "@/components/general/demo/GaFeedbackDemo";
// @ts-ignore
import { MIABOverviewPage } from "@/components/miab/MIABOverviewPage";
// @ts-ignore
import { ContentCardDemo } from "@/components/general/demo/ContentCardDemo";
// @ts-ignore
import { DateFormattingDemo } from "@/components/general/demo/DateFormattingDemo";
// @ts-ignore
import { LeadFormWidget } from "@/components/leadform/LeadFormWidget";
// @ts-ignore
import { ExpertVideoOverviewPage } from "@/components/expertVideo/ExpertVideoOverviewPage";
// @ts-ignore
import { ExpertVideoDetailPage } from "@/components/expertVideo/ExpertVideoDetailPage";
// @ts-ignore
import { ExploreNavigation } from "@/components/explore/ExploreNavigation";
// @ts-ignore
import { ExploreBreadcrumb } from "@/components/explore/ExploreBreadcrumb";
// @ts-ignore
import { SkillPageContent } from "@/components/skill/SkillPageContent";
// @ts-ignore
import type { ActionableReflectSectionProps, ActionableActionbarProps, FullSearchProps, AskGetabstractProperties, VerifaiCreatorPageProps, VerifaiNavigationProps, WarmupWidgetProps, SummaryCardDemoProps, MIABPageProps, MIABOverviewPageProps, ContentCardDemoProps, DateFormattingDemoProps, LeadFormProps, ExpertVideoDetailPageProps, ExploreNavigationProps, SkillPageContentProps } from "@newgenerated/shared/schema";
// @ts-ignore
import { parseActionableReflectSectionProps } from "@generated/model/actionableReflectSectionProps";
// @ts-ignore
import { parseActionableActionbarProps } from "@generated/model/actionableActionbarProps";
// @ts-ignore
import { parseFullSearchProps } from "@generated/model/fullSearchProps";
// @ts-ignore
import { parseAskGetabstractProperties } from "@generated/model/askGetabstractProperties";
// @ts-ignore
import { parseVerifaiCreatorPageProps } from "@generated/model/verifaiCreatorPageProps";
// @ts-ignore
import { parseVerifaiNavigationProps } from "@generated/model/verifaiNavigationProps";
// @ts-ignore
import { parseWarmupWidgetProps } from "@generated/model/warmupWidgetProps";
// @ts-ignore
import { parseSummaryCardDemoProps } from "@generated/model/summaryCardDemoProps";
// @ts-ignore
import { parseMIABPageProps } from "@generated/model/mIABPageProps";
// @ts-ignore
import { parseMIABOverviewPageProps } from "@generated/model/mIABOverviewPageProps";
// @ts-ignore
import { parseContentCardDemoProps } from "@generated/model/contentCardDemoProps";
// @ts-ignore
import { parseDateFormattingDemoProps } from "@generated/model/dateFormattingDemoProps";
// @ts-ignore
import { parseLeadFormProps } from "@generated/model/leadFormProps";
// @ts-ignore
import { parseExpertVideoDetailPageProps } from "@generated/model/expertVideoDetailPageProps";
// @ts-ignore
import { parseExploreNavigationProps } from "@generated/model/exploreNavigationProps";
// @ts-ignore
import { parseSkillPageContentProps } from "@generated/model/skillPageContentProps";

export type ActionableReflectSectionContext = { t: TranslationFn;  }
const ActionableReflectSectionWidget = defineComponent({
   props: {
       actionableReflectSectionProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ActionableReflectSectionContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseActionableReflectSectionProps(props.actionableReflectSectionProps);
       // @ts-ignore
       return () => <ActionableReflectSection actionableReflectSectionProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ActionableReflectSection", ActionableReflectSectionWidget);

export type ActionableActionbarContext = { t: TranslationFn; hasFeature: HasFeatureFn }
const ActionableActionbarWidget = defineComponent({
   props: {
       actionableActionbarProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ActionableActionbarContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseActionableActionbarProps(props.actionableActionbarProps);
       // @ts-ignore
       return () => <ActionableActionbar actionableActionbarProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ActionableActionbar", ActionableActionbarWidget);

export type FullSearchContext = { t: TranslationFn; hasFeature: HasFeatureFn }
const FullSearchWidget = defineComponent({
   props: {
       fullSearchProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<FullSearchContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseFullSearchProps(props.fullSearchProps);
       // @ts-ignore
       return () => <FullSearch fullSearchProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("FullSearch", FullSearchWidget);

export type AskGetabstractWidgetContext = { t: TranslationFn;  }
const AskGetabstractWidgetWidget = defineComponent({
   props: {
       askGetabstractProperties: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<AskGetabstractWidgetContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseAskGetabstractProperties(props.askGetabstractProperties);
       // @ts-ignore
       return () => <AskGetabstractWidget askGetabstractProperties={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("AskGetabstractWidget", AskGetabstractWidgetWidget);

export type AskGetabstractIframeContext = { t: TranslationFn;  }
const AskGetabstractIframeWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<AskGetabstractIframeContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <AskGetabstractIframe context={props.context} />;
   },
});
registerVueWidgetForJsp("AskGetabstractIframe", AskGetabstractIframeWidget);

export type AskGetabstractDemoContext = { t: TranslationFn;  }
const AskGetabstractDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<AskGetabstractDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <AskGetabstractDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("AskGetabstractDemo", AskGetabstractDemoWidget);

export type VerifaiCreatorPageContext = { t: TranslationFn;  }
const VerifaiCreatorPageWidget = defineComponent({
   props: {
       verifaiCreatorPageProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<VerifaiCreatorPageContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseVerifaiCreatorPageProps(props.verifaiCreatorPageProps);
       // @ts-ignore
       return () => <VerifaiCreatorPage verifaiCreatorPageProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("VerifaiCreatorPage", VerifaiCreatorPageWidget);

export type VerifaiNavigationContext = { t: TranslationFn;  }
const VerifaiNavigationWidget = defineComponent({
   props: {
       verifaiNavigationProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<VerifaiNavigationContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseVerifaiNavigationProps(props.verifaiNavigationProps);
       // @ts-ignore
       return () => <VerifaiNavigation verifaiNavigationProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("VerifaiNavigation", VerifaiNavigationWidget);

export type GaTopLayerContext = { t: TranslationFn;  }
const GaTopLayerWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<GaTopLayerContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <GaTopLayer context={props.context} />;
   },
});
registerVueWidgetForJsp("GaTopLayer", GaTopLayerWidget);

export type WarmupContext = { t: TranslationFn;  }
const WarmupWidget = defineComponent({
   props: {
       warmupWidgetProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<WarmupContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseWarmupWidgetProps(props.warmupWidgetProps);
       // @ts-ignore
       return () => <Warmup warmupWidgetProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("Warmup", WarmupWidget);

export type WarmupDemoContext = { t: TranslationFn;  }
const WarmupDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<WarmupDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <WarmupDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("WarmupDemo", WarmupDemoWidget);

export type ModalDemoContext = { t: TranslationFn;  }
const ModalDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<ModalDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <ModalDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("ModalDemo", ModalDemoWidget);

export type ExperimentalGeneratorDemoContext = { t: TranslationFn;  }
const ExperimentalGeneratorDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<ExperimentalGeneratorDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <ExperimentalGeneratorDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("ExperimentalGeneratorDemo", ExperimentalGeneratorDemoWidget);

export type GaProgressCircleDemoContext = { t: TranslationFn;  }
const GaProgressCircleDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<GaProgressCircleDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <GaProgressCircleDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("GaProgressCircleDemo", GaProgressCircleDemoWidget);

export type SummaryCardDefaultDemoContext = { t: TranslationFn;  }
const SummaryCardDefaultDemoWidget = defineComponent({
   props: {
       summaryCardDemoProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<SummaryCardDefaultDemoContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseSummaryCardDemoProps(props.summaryCardDemoProps);
       // @ts-ignore
       return () => <SummaryCardDefaultDemo summaryCardDemoProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("SummaryCardDefaultDemo", SummaryCardDefaultDemoWidget);

export type SummaryCardCompactDemoContext = { t: TranslationFn;  }
const SummaryCardCompactDemoWidget = defineComponent({
   props: {
       summaryCardDemoProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<SummaryCardCompactDemoContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseSummaryCardDemoProps(props.summaryCardDemoProps);
       // @ts-ignore
       return () => <SummaryCardCompactDemo summaryCardDemoProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("SummaryCardCompactDemo", SummaryCardCompactDemoWidget);

export type SummaryCardMiniDemoContext = { t: TranslationFn;  }
const SummaryCardMiniDemoWidget = defineComponent({
   props: {
       summaryCardDemoProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<SummaryCardMiniDemoContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseSummaryCardDemoProps(props.summaryCardDemoProps);
       // @ts-ignore
       return () => <SummaryCardMiniDemo summaryCardDemoProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("SummaryCardMiniDemo", SummaryCardMiniDemoWidget);

export type FullSearchAiDemoComponentContext = { t: TranslationFn;  }
const FullSearchAiDemoComponentWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<FullSearchAiDemoComponentContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <FullSearchAiDemoComponent context={props.context} />;
   },
});
registerVueWidgetForJsp("FullSearchAiDemoComponent", FullSearchAiDemoComponentWidget);

export type MIABPageContext = { t: TranslationFn;  }
const MIABPageWidget = defineComponent({
   props: {
       miabPageProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<MIABPageContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseMIABPageProps(props.miabPageProps);
       // @ts-ignore
       return () => <MIABPage miabPageProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("MIABPage", MIABPageWidget);

export type BadgeDemoContext = { t: TranslationFn;  }
const BadgeDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<BadgeDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <BadgeDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("BadgeDemo", BadgeDemoWidget);

export type GaFeedbackDemoContext = { t: TranslationFn;  }
const GaFeedbackDemoWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<GaFeedbackDemoContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <GaFeedbackDemo context={props.context} />;
   },
});
registerVueWidgetForJsp("GaFeedbackDemo", GaFeedbackDemoWidget);

export type MIABOverviewPageContext = { t: TranslationFn;  }
const MIABOverviewPageWidget = defineComponent({
   props: {
       miabOverviewPageProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<MIABOverviewPageContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseMIABOverviewPageProps(props.miabOverviewPageProps);
       // @ts-ignore
       return () => <MIABOverviewPage miabOverviewPageProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("MIABOverviewPage", MIABOverviewPageWidget);

export type ContentCardDemoContext = { t: TranslationFn;  }
const ContentCardDemoWidget = defineComponent({
   props: {
       contentCardDemoProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ContentCardDemoContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseContentCardDemoProps(props.contentCardDemoProps);
       // @ts-ignore
       return () => <ContentCardDemo contentCardDemoProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ContentCardDemo", ContentCardDemoWidget);

export type DateFormattingDemoContext = { t: TranslationFn;  }
const DateFormattingDemoWidget = defineComponent({
   props: {
       dateFormattingDemoProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<DateFormattingDemoContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseDateFormattingDemoProps(props.dateFormattingDemoProps);
       // @ts-ignore
       return () => <DateFormattingDemo dateFormattingDemoProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("DateFormattingDemo", DateFormattingDemoWidget);

export type LeadFormWidgetContext = { t: TranslationFn;  }
const LeadFormWidgetWidget = defineComponent({
   props: {
       leadFormProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<LeadFormWidgetContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseLeadFormProps(props.leadFormProps);
       // @ts-ignore
       return () => <LeadFormWidget leadFormProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("LeadFormWidget", LeadFormWidgetWidget);

export type ExpertVideoOverviewPageContext = { t: TranslationFn;  }
const ExpertVideoOverviewPageWidget = defineComponent({
   props: {
       context: {
          type: Object as PropType<ExpertVideoOverviewPageContext>,
          required: true,
       },
   },
   setup(props) {
       // @ts-ignore
       return () => <ExpertVideoOverviewPage context={props.context} />;
   },
});
registerVueWidgetForJsp("ExpertVideoOverviewPage", ExpertVideoOverviewPageWidget);

export type ExpertVideoDetailPageContext = { t: TranslationFn;  }
const ExpertVideoDetailPageWidget = defineComponent({
   props: {
       detailPageProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ExpertVideoDetailPageContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseExpertVideoDetailPageProps(props.detailPageProps);
       // @ts-ignore
       return () => <ExpertVideoDetailPage detailPageProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ExpertVideoDetailPage", ExpertVideoDetailPageWidget);

export type ExploreNavigationContext = { t: TranslationFn;  }
const ExploreNavigationWidget = defineComponent({
   props: {
       exploreNavigationProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ExploreNavigationContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseExploreNavigationProps(props.exploreNavigationProps);
       // @ts-ignore
       return () => <ExploreNavigation exploreNavigationProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ExploreNavigation", ExploreNavigationWidget);

export type ExploreBreadcrumbContext = { t: TranslationFn;  }
const ExploreBreadcrumbWidget = defineComponent({
   props: {
       exploreNavigationProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<ExploreBreadcrumbContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseExploreNavigationProps(props.exploreNavigationProps);
       // @ts-ignore
       return () => <ExploreBreadcrumb exploreNavigationProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("ExploreBreadcrumb", ExploreBreadcrumbWidget);

export type SkillPageContentContext = { t: TranslationFn;  }
const SkillPageContentWidget = defineComponent({
   props: {
       skillPageContentProps: {
           type: Object as PropType<unknown>,
           required: true,
       },
       context: {
          type: Object as PropType<SkillPageContentContext>,
          required: true,
       },
   },
   setup(props) {
       const parsed = parseSkillPageContentProps(props.skillPageContentProps);
       // @ts-ignore
       return () => <SkillPageContent skillPageContentProps={parsed} context={props.context} />;
   },
});
registerVueWidgetForJsp("SkillPageContent", SkillPageContentWidget);

